export const useFileUpload = false;

export const useCategoryTree = false;